<template>
  <div class="oder_management">
    <div ref="tablePanel" class="fullheight">
      <div class="table_content">
        <div class="top_search">
          <el-row style="height: 100%; width: 100%; position: relative">
            <el-col :span="24" class="col_style">
              <el-tabs @tab-click="handleClick" v-model="tabsVal" style="width: 100%">
                <el-tab-pane :label="item.label" :name="item.name" v-for="item in tabList" :key="item.index"></el-tab-pane> </el-tabs
            ></el-col>
            <div class="absolutePa">
              <div class="col_style5">
                <p>订单日期：</p>
                <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="dateRangeVal"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="loadData"
                >
                </el-date-picker>
              </div>
              <div class="col_style5">
                <el-input
                  v-if="tenantId == '-1'"
                  v-model="code"
                  @change="loadData"
                  :clearable="true"
                  :placeholder="placeholder"
                  suffix-icon="el-icon-search"
                  @keyup.enter.native="loadData"
                >
                  <!-- <el-button slot="append" type="primary" @click="loadData" size="small">搜索</el-button> -->
                </el-input>
                <el-input
                  v-else
                  v-model="code"
                  @change="loadData"
                  :clearable="true"
                  :placeholder="placeholder"
                  suffix-icon="el-icon-search"
                  @keyup.enter.native="loadData"
                >
                  <!-- <el-button slot="append" type="primary" @click="loadData" size="small">搜索</el-button> -->
                </el-input>
              </div>
            </div>
          </el-row>
        </div>
        <el-table
          ref="ecoTable"
          :style="{
            height: `${tableMaxHeight}` + 'px'
          }"
          :max-height="tableMaxHeight"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          border
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
        >
          <el-table-column type="selection" width="55" align=" left"> </el-table-column>
          <el-table-column type="index" label="序号" width="55"> </el-table-column>
          <el-table-column prop="order_no" label="订单编号" show-overflow-tooltip v-if="tabsVal == '3,4'">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="orderRecord(scope.row.refId)">{{ scope.row.order_no }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="order_time" label="订单日期" show-overflow-tooltip v-if="tabsVal == '3,4'"> </el-table-column>
          <el-table-column prop="customer_name" label="客户名称" show-overflow-tooltip v-if="tabsVal == '3,4'"></el-table-column>
          <el-table-column prop="account_name" label="产品名称" show-overflow-tooltip v-if="tabsVal == '3,4'"></el-table-column>
          <el-table-column prop="order_amount" label="订单金额" show-overflow-tooltip :formatter="numberFormatter" v-if="tabsVal == '3,4'"> </el-table-column>
          <el-table-column prop="order_status" label="订单状态" show-overflow-tooltip v-if="tabsVal == '3,4'">
            <template slot-scope="scope">
              {{
                scope.row.order_status == 0
                  ? '已取消'
                  : scope.row.order_status == 1
                  ? '待确认'
                  : scope.row.order_status == 2
                  ? '待付款'
                  : scope.row.order_status == 3
                  ? '已付款'
                  : scope.row.order_status == 4
                  ? '付款已确认'
                  : scope.row.order_status == 5
                  ? '待开票'
                  : scope.row.order_status == 6
                  ? '已开票'
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column prop="payment_no" label="付款单号" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="paymentRecord(scope.row.id, scope.row.payment_status)">{{ scope.row.payment_no }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="payment_time" label="付款单日期" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="pay_method" label="付款方式" show-overflow-tooltip v-if="tabsVal == '3,4'">
            <template slot-scope="scope">
              {{ scope.row.pay_method == '1' ? '对公转账' : scope.row.pay_method == '2' ? '支付宝' : scope.row.pay_method == '3' ? '微信' : '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="payment_amount" label="付款单金额" show-overflow-tooltip :formatter="numberFormatter"> </el-table-column>
          <el-table-column prop="payment_status" label="付款单状态" show-overflow-tooltip v-if="tabsVal == '3,4' || tabsVal == '0'">
            <template slot-scope="scope">
              {{
                scope.row.payment_status == 0
                  ? '已取消'
                  : scope.row.payment_status == 1
                  ? '待确认'
                  : scope.row.payment_status == 2
                  ? '待付款'
                  : scope.row.payment_status == 3
                  ? '已付款'
                  : scope.row.payment_status == 4
                  ? '付款已确认'
                  : scope.row.payment_status == 5
                  ? '待开票'
                  : scope.row.payment_status == 6
                  ? '已开票'
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column prop="pay_amount" label="实际收款" show-overflow-tooltip :formatter="numberFormatter" v-if="tabsVal == '3,4'"> </el-table-column>
          <el-table-column prop="name" label="操作" v-if="tabsVal == '3,4' && tenantId == '-1'">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" v-if="tenantId == '-1' && scope.row.payment_status == 3" @click="confirmPayment(scope.row.id)"
                >确认收款</el-link
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="page_bean">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 50, 100, 500]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 付款确认 -->
      <payment-confirm v-if="showPaymentConfirm" :show="showPaymentConfirm" :paymentId="paymentId" @closePaymentConfirm="closePaymentConfirm">
      </payment-confirm>
      <!-- 订单详情 -->
      <order-record :show="showOrderRecord" :orderId="orderId" @closeOrderRecord="closeOrderRecord"> </order-record>
      <!-- 付款记录 -->
      <payment-record :show="showPaymentRecord" :paymentId="paymentId" :isCancle="isCancle" @closePaymentRecord="closePaymentRecord"> </payment-record>
    </div>
  </div>
</template>

<script>
import OrderRecord from './billingCenter/orderRecord.vue'
import PaymentRecord from './billingCenter/paymentRecord.vue'
import PaymentConfirm from './billingCenter/paymentConfirm.vue'
import utils from '@/utils.js'
export default {
  components: { OrderRecord, PaymentRecord, PaymentConfirm },
  data() {
    return {
      tenantId: '-1',
      dateRangeVal: '',
      code: '',
      tabsVal: '3,4',
      tableData: [],
      tableMaxHeight: document.body.clientHeight - 250,
      total: 0,
      pageSize: 20,
      currentPage: 1,
      orderId: '',
      isEdit: false,
      showOrderRecord: false,
      showPaymentRecord: false,
      showPaymentConfirm: false,
      isCancle: false,
      paymentId: '',
      tabList: [],
      placeholder: '请输入订单编号,客户名称搜索'
    }
  },
  mounted() {
    this.loadData()
    this.calcTableHeight()
    this.$root.$on('resize', () => {
      this.calcTableHeight(500)
      this.$nextTick(() => {
        this.$refs.ecoTable.doLayout()
      })
    })
    if (sessionStorage.currentTenantId) {
      this.placeholder = '请输入订单编号搜索'
      this.tenantId = sessionStorage.currentTenantId
    }
  },
  methods: {
    //获取每个tab数量
    getCount() {
      // this.tabList = [
      //   { label: "已付款(0)", name: "3,4" },
      //   {
      //     label: "已取消(0)",
      //     name: "0"
      //   }
      // ];
      let params = {
        pageBean: {
          page: 1,
          pageSize: 10,
          total: 0
        }
      }
      if (this.code || this.dateRangeVal) {
        params.querys = []
        if (this.code) {
          if (this.tabsVal == '3,4') {
            params.querys.push({
              group: 'advance',
              value: this.code,
              relation: 'OR',
              operation: 'LIKE',
              property: 'third_order.order_no'
            })
            if (this.tenantId == '-1') {
              params.querys.push({
                group: 'advance',
                value: this.code,
                relation: 'OR',
                operation: 'LIKE',
                property: 'third_order.customer_name'
              })
            }
          } else {
            params.querys.push({
              group: 'advance',
              value: this.code,
              relation: 'AND',
              operation: 'LIKE',
              property: 'payment_no'
            })
          }
        }
        if (this.dateRangeVal) {
          params.querys.push({
            group: 'advance',
            operation: 'BETWEEN',
            property: 'third_order.order_time',
            relation: 'AND',
            value: this.dateRangeVal
          })
        }
      }

      this.$http.post('${third}/costcenter/third_payment/queryCount', params).then((res) => {
        if (res.data) {
          res.data.total = parseFloat(res.data.payment_confirmed) + parseFloat(res.data.payment_received)
          this.tabList = [
            { label: '已付款(' + res.data.total + ')', name: '3,4' },
            {
              label: '已取消(' + res.data.already_canceled + ')',
              name: '0'
            }
          ]
        }
      })
    },
    //千分位格式化
    numberFormatter(row, column) {
      var val = row[column.property]
      if (val == undefined) {
        return ''
      }
      return utils.dataTransform(val.toString())
    },
    //付款确认
    confirmPayment(id) {
      this.paymentId = ''
      this.isEdit = false
      if (id) {
        this.paymentId = id
      }
      this.showPaymentConfirm = true
    },
    //付款确认关闭
    closePaymentConfirm() {
      this.showPaymentConfirm = false
      this.loadData()
    },
    //查看订单详情
    orderRecord(id) {
      this.orderId = ''
      if (id) {
        this.orderId = id
      }
      this.showOrderRecord = true
    },
    //订单详情关闭
    closeOrderRecord() {
      this.showOrderRecord = false
    },
    //订单付款记录
    paymentRecord(id, status) {
      this.isCancle = false
      this.paymentId = ''
      if (id) {
        this.paymentId = id
      }
      if (status == '0') {
        this.isCancle = true
      }
      this.showPaymentRecord = true
    },
    //订单付款记录关闭
    closePaymentRecord() {
      this.showPaymentRecord = false
    },
    //表头样式
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      const obj = {
        backgroundColor: '#F3F3F3',
        color: '#333333'
      }
      if (column.type == 'selection') obj.textAlign = 'center'
      return obj
    },
    //列表样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let str = column.label
      if (str && str != undefined) {
        if (str.indexOf('金额') > -1 || str.indexOf('收款') > -1) {
          return 'text-align:right'
        } else {
          return 'text-align:left'
        }
      } else {
        return 'text-align:center'
      }
    },
    //tabs切换事件
    handleClick(tab) {
      this.code = ''
      this.currentPage = 1
      this.tabsVal = tab.name
      if (tab.name == '3,4') {
        if (this.tenantId == '-1') {
          this.placeholder = '请输入订单编号,客户名称搜索'
        } else {
          this.placeholder = '请输入订单编号搜索'
        }
      }
      if (tab.name == '0') {
        this.placeholder = '请输入付款单号搜索'
      }
      this.loadData()
    },
    //table勾选事件
    handleSelectionChange() {},
    //每页数量调整
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    //页数跳转
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    // 动态计算表格的高度，自适应当前容器
    calcTableHeight(delay) {
      setTimeout(() => {
        if (!this.$refs.tablePanel) {
          return
        }
        const tablePanelHeight = this.$refs.tablePanel.$el.clientHeight
        this.tableMaxHeight = tablePanelHeight - 180
      }, delay || 0)
    },
    //表格排序
    // sortChange(row) {
    //   let props = row.prop;
    //   switch (row.order) {
    //     case "descending":
    //       this.loadData(props, "DESC");
    //       break;
    //     case "ascending":
    //       this.loadData(props, "ASC");
    //       break;
    //     case null:
    //       break;
    //   }
    // },
    //table数据加载
    loadData() {
      this.getCount()
      this.tableData = []
      let params = {
        pageBean: {
          page: this.currentPage,
          pageSize: this.pageSize,
          total: 0
        }
      }
      if (this.code || this.dateRangeVal || this.tabsVal) {
        params.querys = []
        if (this.code) {
          if (this.tabsVal == '3,4') {
            params.querys.push({
              group: 'advance',
              value: this.code,
              relation: 'OR',
              operation: 'LIKE',
              property: 'third_order.order_no'
            })
            if (this.tenantId == '-1') {
              params.querys.push({
                group: 'advance',
                value: this.code,
                relation: 'OR',
                operation: 'LIKE',
                property: 'third_order.customer_name'
              })
            }
          } else {
            params.querys.push({
              group: 'advance',
              value: this.code,
              relation: 'AND',
              operation: 'LIKE',
              property: 'payment_no'
            })
          }
        }
        if (this.dateRangeVal) {
          params.querys.push({
            group: 'advance',
            operation: 'BETWEEN',
            property: 'third_order.order_time',
            relation: 'AND',
            value: this.dateRangeVal
          })
        }
        if (this.tabsVal) {
          params.querys.push({
            group: 'advance',
            value: this.tabsVal,
            relation: 'AND',
            operation: 'IN',
            property: 'payment_status'
          })
        }
      }
      // if (prop) {
      //   params.sorter = [{ property: prop, direction: sort }];
      // }
      this.$http.post('${third}/costcenter/third_payment/query', params).then((res) => {
        let response = res.data
        this.total = response.total
        response.rows.forEach((item) => {
          if (item.order_time) {
            let arr = item.order_time.split(' ')
            item.order_time = arr[0]
          }
        })
        this.tableData = response.rows
        this.$refs.ecoTable.doLayout()
      })
    }
  }
}
</script>

<style scoped>
.oder_management {
  padding-top: 10px;
  height: calc(100% - 20px);
}
/deep/td:first-child .cell {
  padding-left: 14px !important;
}
/deep/.el-table--border {
  padding-left: 0 !important;
}
.top_search {
  padding-bottom: 10px;
  height: 45px;
  width: 100%;
  display: flex;
  align-items: center;
}
.col_style {
  height: 100%;
  display: flex;
  align-items: center;
}
.col_style p {
  flex-shrink: 0;
}
/deep/.el-input-group__append button.el-button {
  border-color: transparent;
  background-color: #377cff;
  color: white;
  border-top: 0;
  border-bottom: 0;
}
.button_group {
  height: 40px;
  display: flex;
  justify-content: right;
  align-items: center;
}
.page_bean {
  display: flex;
  justify-content: right;
  align-items: center;
}
/deep/.el-table--scrollable-y .el-table__body-wrapper {
  overflow-y: auto;
}

.absolutePa {
  position: absolute;
  right: 10px;
  top: -10px;
  width: 60%;
  display: flex;
  justify-content: flex-end;
  z-index: 2;
}
.col_style5 {
  display: flex;
  align-items: center;
  margin-left: 10px;
  width: 48%;
}
.col_style5 p {
  flex-shrink: 0;
}
</style>
